<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('实名认证')}}</div>
		<div></div>
	</header>
	<div class="z-body recharge-body">
		<div class="z-flex recharge-row" v-if="state>0">
			<div>{{$t('状态')}}</div>
			<div>
				<span style="color:#ff9800;" v-if="state==1">{{$t('待审核')}}</span>
				<span style="color:#09bb07;" v-else-if="state==2">{{$t('审核通过')}}</span>
				<span style="color:#666666;" v-else-if="state==3">{{$t('审核拒绝')}}</span>
			</div>
		</div>
		<div class="z-flex recharge-row" v-if="state==3">
			<div>{{$t('说明')}}</div>
			<div v-text="reason"></div>
		</div>
		<div class="z-flex recharge-row">
			<div>{{$t('姓名')}}</div>
			<div v-if="readonly" v-text="real_name"></div>
			<div style="height: 100%;width:80%;" v-else>
				<input type="text" style="height: 100%;width:100%;color:#fff" :placeholder="$t('请输入')+$t('姓名')" v-model="real_name">
			</div>
		</div>
		<div class="z-flex recharge-row" style="border-bottom:1px solid #F5F5F5;">
			<div>{{$t('身份证编号')}}</div>
			<div v-if="readonly" v-text="card_no"></div>
			<div style="height: 100%;width:80%;" v-else>
				<input type="text" style="height: 100%;width:100%;color:#fff" :placeholder="$t('请输入')+$t('身份证编号')" v-model="card_no">
			</div>
		</div>


		<div class="z-flex realName-cards" v-if="state<=0 || state==3">
			<div>
				<img :src="url_card_front" style="width:auto;height:120px;">
				<input v-if="state==0||state==3" type="file" @change="handleFile($event,'card_front','url_card_front')">
			</div>
			<div>
				<img :src="url_card_back" style="width:auto;height:120px;">
				<input v-if="state==0||state==3" type="file" @change="handleFile($event,'card_back','url_card_back')">
			</div>
			<!-- <div>
				<img :src="url_hand" style="width:auto;height:120px;">
				<input v-if="state==0||state==3" type="file" @change="handleFile($event,'hand','url_hand')">
			</div> -->
		</div>

		<section style="text-align: center;margin-bottom: 50px;" v-if="state==0||state==3">
			<button :disabled="disabled" @click="doPost"  class="common-btn">{{$t('提交')}}</button>
		</section>
	</div>
</div>
</template>
<script>
export default {
	name: 'realName',
	data() {
		return {
			readonly:true,
			state:0, //0待提交 1提交待审核；2通过；3拒绝
			reason:'',
			card_front:'',
			card_back:'',
			hand:'',
			url_card_front:require('../../assets/my/realName/zm@2x.png'),
			url_card_back:require('../../assets/my/realName/fm@2x.png'),
			url_hand:require('../../assets/my/realName/sc@2x.png'),
			real_name:'',
			card_no:'',
      disabled:false,
		}
	},
	mounted() {
	},
	created() {
		this.doInit()
	},
	methods: {
		doInit:function () {
			this.post('api/users/identification', {}).then((res) => {
				if (res.code == 0) {
					this.state = res.data.state
					this.reason = res.data.reason
					if (this.state==1||this.state==2) {
						this.readonly = true
					}
					else {
						this.readonly = false
					}
					if (this.state>0) {
						this.card_front = res.data.field.card_front
						this.card_back = res.data.field.card_back
						this.hand = res.data.field.hand
						// this.url_card_front = res.data.field.card_front
						// this.url_card_back = res.data.field.card_back
						// this.url_hand = res.data.field.hand

						this.card_no = this.hideStr(res.data.field.card_no,1,1)
						this.real_name = this.hideStr(res.data.field.username,1,1)
					}
				}
				else {
				  this.$store.commit('layer', res.msg)
				}
			})
		},
		doPost:function () {
      let that = this;
      this.disabled = true;
			this.post('api/user_verify/addVerify', {
				card_front:this.card_front,
				card_back:this.card_back,
				hand:this.hand,
				real_name:this.real_name,
				card_no:this.card_no,
			}).then((res) => {
				this.$store.commit('layer',res.msg);
        setTimeout(function() {
          that.disabled = false;
        }, 1000);
				if (res.code == 0) {
					this.jump('/my')
				}
			})
		},
		//上传
		  handleFile: function(event,post_url,show_url) {
			event.preventDefault();
			var _this = this;
			let file = event.target.files[0];
			// 看支持不支持FileReader
			if (!file || !window.FileReader) return;
			if (/^image/.test(file.type)) {
			  // 创建一个reader
			  let reader = new FileReader();
			  // 将图片将转成 base64 格式
			  reader.readAsDataURL(file);
			  // 读取成功后的回调
			  reader.onloadend = function() {
				_this[show_url] = this.result;
			  }
			}
			var formData = new FormData();
			formData.append('file', file);
			formData.append('token', _this.getToken());
			_this.upload('api/member/upFile.html', formData).then((res) => {
			  if (res.code == 0) {
				_this[show_url] = res.data
				_this[post_url] = res.data
			  } else {
				_this.$store.commit('layer', res.msg)
			  }
			})
		  },
	}
}
</script>
<style scoped>
.realName-cards{

	flex-direction:column;
	padding:30px 10px;
}
.realName-cards div{
	position: relative;
	margin-bottom: 20px;
}
.realName-cards input{
	position: relative;
	position:absolute;
	width: 100%;
	height: 100%;
	left:0;
	right:0;
	top:0;
	bottom:0;
	z-index:999;
	opacity:0;
}
.recharge-tips {
	font-size: 16px;
	padding: 10px;
}
.recharge-tips p{
	margin-bottom: 10px;
}
.recharge-row {
	height:50px;
	justify-content:space-between;
	border-bottom: 1px solid #F5F5F5;
	padding:0 10px;
}
.recharge-row div:nth-child(1){
	color: #aaa5a5;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/realName.vue